//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "MortalityInOlderAdultsAfterHospitalization",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6:''
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "1", name: "男" },
        { value: "0", name: "女" },
      ],
      dataList1: [
      { value: "0", name: "无ADL依赖" },
      { value: "2", name: "1~4个ADL依赖" },
      { value: "5", name: "5个ADL依赖" },
      ],
      dataList2: [
        { value: "2", name: "有" },
        { value: "0", name: "无" },
      ],
      dataList3: [
      { value: "0", name: "无" },
      { value: "3", name: "孤立" },
      { value: "8", name: "转移" },
      ],
      dataList4: [
        { value: "2", name: "是" },
        { value: "0", name: "否" },
      ],
      dataList5: [
        { value: "2", name: "＜3g/dL" },
        { value: "1", name: "3.0~3.4g/dL" },
        { value: "0", name: "≥3.5g/dL" },
      ],
 
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MortalityInOlderAdultsAfterHospitalization.vue